import {
  SET_WP_CATEGORY_LABELS,
  SET_WP_CATEGORY_IMGINFO,
  // 壁纸--精选
  SET_WP_BANNER_LIST,
  SET_WP_RECOMMEND_LIST,
  SET_WP_DETAIL_RECO_BANNER,
  SET_WP_RECO_BANNER,
  SET_WP_RECO_GROUP,
  SET_WP_RANK_MORE,
  SET_WP_MINE_LIST,
  SET_WP_OPTERAYTION,
  SET_WP_SCREEN_LIST,
  WP_UPDATE_PREVIEW,
  WP_ADD_DOWNLOAD_IMG,
  WP_REMOVE_DOWNLOAD_IMG,
  WP_UPDATE_STATUS_DOWNLOAD_IMG,
  WP_UPDATE_PROGRESS_DOWNLOAD_IMG,
  WP_DOWNLOAD_ING,
  WP_DOWNLOAD_FAILED,
  // 壁纸 作者列表
  SET_WP_AUTHOR_LIST,
  // 壁纸 作家作品集
  SET_WP_AUTHOR_SHOWREEL,
  SET_WP_CATEGORY_STATUS,
  SET_SCROLL,
  CANCEL_WP_MINE_COLLECTORSETUP,
} from '../constants/wallpaper';

const initState = {
  scroll: {
    mineScrollTop: null,
    categoryScrollTop: null,
    recommendScrollTop: null,
    rankScrollTop: null,
    authorListScrollTop: null,
    authorScrollTop: null,
  },
  wpDetailReco: {},
  rankList: {
    list: [],
    pagenation: {
      skip: 0,
      limit: 24,
      count: 0,
    },
    load: null,
  },
  recoBanners: {},
  recoGroups: [],
  bannerList: [],
  recommendInfo: {
    list: [],
    name: '',
    pagenation: {
      skip: 0,
      limit: 24,
      count: 0,
    },
    load: false,
  },
  labelList: [],
  categoryInfo: {
    pagenation: {
      skip: 0,
      limit: 54,
      count: 0,
      tagId: '-1',
      colorId: '-1',
      classId: '-1',
    },
    list: [],
    load: false,
    status: {
      classStatus: 'collapse',
      tagStatus: 'collapse',
    },
  },
  mineInfo: {
    pagenation: {
      skip: 0,
      limit: 24,
      count: 0,
      tagId: 'setup',
    },
    list: [],
    load: false,
  },
  wpScreen: {
    load: false,
    pagenation: {
      skip: 0,
      limit: 24,
      count: 0,
    },
    list: [],
  },
  wpOpteration: {
    load: false,
  },
  wpPreviewInfo: {
    isShow: false,
  },
  wpDowloadImgs: [],
  wpAuthorList: {
    pagenation: {
      skip: 0,
      limit: 24,
      count: 0,
    },
    list: [],
    load: false,
  },
  wpAuthorShowreel: {
    pagenation: {
      skip: 0,
      limit: 24,
      count: 0,
      authorId: null,
    },
    list: [],
    load: false,
  },
};

const wallpaper = (state = initState, action = {}) => {
  let tmp;
  let wallpaperId;
  switch (action.type) {
    case SET_SCROLL:
      return {
        ...state,
        scroll: {
          ...state.scroll,
          ...action.payload,
        },
      };
    case SET_WP_DETAIL_RECO_BANNER:
      return { ...state, wpDetailReco: action.payload };
    case SET_WP_RANK_MORE:
      return { ...state, rankList: action.payload };
    case SET_WP_RECO_BANNER:
      return { ...state, recoBanners: action.payload };
    case SET_WP_RECO_GROUP:
      return { ...state, recoGroups: action.payload };
    case SET_WP_BANNER_LIST:
      return {
        ...state,
        bannerList: action.payload,
      };
    case SET_WP_RECOMMEND_LIST:
      return {
        ...state,
        recommendInfo: { ...state.recommendInfo, ...action.payload },
      };
    case SET_WP_CATEGORY_LABELS:
      return {
        ...state,
        labelList: action.payload,
      };
    case SET_WP_CATEGORY_IMGINFO:
      return {
        ...state,
        categoryInfo: { ...state.categoryInfo, ...action.payload },
      };
    case SET_WP_MINE_LIST:
      return {
        ...state,
        mineInfo: {
          ...state.mineInfo,
          ...action.payload,
        },
      };
    case SET_WP_OPTERAYTION:
      return {
        ...state,
        wpOpteration: {
          ...state.wpOpteration,
          ...action.payload,
        },
      };
    case SET_WP_SCREEN_LIST:
      return {
        ...state,
        wpScreen: {
          ...state.wpOpteration,
          ...action.payload,
        },
      };
    case WP_UPDATE_PREVIEW:
      return { ...state, wpPreviewInfo: action.info };
    // 添加更新下载任务
    case WP_ADD_DOWNLOAD_IMG:
      wallpaperId = action.wallpaper.wallpaperId || action.wallpaper.id;
      tmp = state.wpDowloadImgs.find(v => v.wallpaperId === wallpaperId);
      // 去重
      if (tmp) {
        if (tmp.status === WP_DOWNLOAD_FAILED) {
          tmp.status = WP_DOWNLOAD_ING;
          tmp.averagespeed = 0;
          tmp.progress = 0;
          tmp.taskid = null;
          tmp.path = null;
          tmp.type = action.wallpaper.type;
          return { ...state, wpDowloadImgs: [...state.wpDowloadImgs] };
        }
        return state;
      }
      return { ...state, wpDowloadImgs: [...state.wpDowloadImgs, action.wallpaper] };
    // 删除下载任务
    case WP_REMOVE_DOWNLOAD_IMG:
      wallpaperId = action.wallpaper.wallpaperId || action.wallpaper.id;
      tmp = state.wpDowloadImgs.filter(v => v.wallpaperId !== wallpaperId);
      return { ...state, wpDowloadImgs: tmp };
    // 更改下载任务某个任务状态
    case WP_UPDATE_STATUS_DOWNLOAD_IMG:
      wallpaperId = action.wallpaper.wallpaperId || action.wallpaper.id;
      state.wpDowloadImgs.some(v => {
        if (v.wallpaperId === wallpaperId) {
          const tmpObj = v;
          tmpObj.status = action.wallpaper.status;
          tmpObj.taskid = action.wallpaper.taskid;
          tmpObj.averagespeed = action.wallpaper.averagespeed || 0;
          tmpObj.path = action.wallpaper.path;
          tmpObj.type = action.wallpaper.type;
          if (action.wallpaper.status === 1) {
            tmpObj.progress = 0;
          } else if (action.wallpaper.status === 2) {
            tmpObj.progress = 100;
          }
          return true;
        }
        return false;
      });
      return { ...state, wpDowloadImgs: [...state.wpDowloadImgs] };
    case WP_UPDATE_PROGRESS_DOWNLOAD_IMG:
      wallpaperId = action.wallpaper.wallpaperId || action.wallpaper.id;
      state.wpDowloadImgs.some(v => {
        if (v.wallpaperId === wallpaperId) {
          const tmpObj = v;
          tmpObj.progress = action.wallpaper.progress || 0;
          tmpObj.downloadSpeed = action.wallpaper.DownloadSpeed;
          tmpObj.averagespeed = action.wallpaper.AverageDownloadSpeed;
          return true;
        }
        return false;
      });
      return { ...state, wpDowloadImgs: [...state.wpDowloadImgs] };
    // 壁纸 作家列表
    case SET_WP_AUTHOR_LIST:
      return { ...state, wpAuthorList: { ...state.wpAuthorList, ...action.payload } };
    // 壁纸 作家作品列表
    case SET_WP_AUTHOR_SHOWREEL:
      return { ...state, wpAuthorShowreel: { ...state.wpAuthorShowreel, ...action.payload } };
    // SET_WP_CATEGORY_STATUS
    case SET_WP_CATEGORY_STATUS: {
      return {
        ...state,
        categoryInfo: {
          ...state.categoryInfo,
          status: {
            ...state.categoryInfo.status,
            ...action.payload,
          },
        },
      };
    }

    case CANCEL_WP_MINE_COLLECTORSETUP:
      return {
        ...state,
        mineInfo: {
          ...state.mineInfo,
          list: state.mineInfo.list.filter(item => item.wallpaperId !== action.payload.wallpaperId),
          pagenation: {
            ...state.mineInfo.pagenation,
            count:
              state.mineInfo.pagenation.count - 1 > 0 ? state.mineInfo.pagenation.count - 1 : 0,
          },
        },
      };
    default:
      return state;
  }
};

export default wallpaper;
